// extracted by mini-css-extract-plugin
module.exports = {"title":"reportAdmin_title__1ymoQ"};